<style>
#usersModal .v--modal-box.v--modal {
  min-width: 700px !important;
  min-height: 450px !important;
}
#usersModal .modal__content {
  margin-top: -50px;
}
#usersModal .modal__footer {
  display: none;
}
/* #usersModal div.ag-theme-balham {
  height: 250px !important;
} */
#usersModal .v-tabs__bar {
  margin-bottom: 10px;
}
.v-tabs,
.v-window,
.v-tabs,
.v-window__container,
.v-window-item,
.v-tabs {
  height: 95%;
}
</style>

<template>
  <div class="wrapper">
    <Modal
      modalName="usersModal"
      title="Zarządzanie użytkownikami"
      :buttons="['']"
      :register="register"
    >
      <v-tabs
        color="white"
        slider-color="#2a579a"
      >
        <v-tab>Użytkownicy</v-tab>
        <v-tab-item>
          <UsersTable />
        </v-tab-item>
        <v-tab @mouseup="initTable">Grupy</v-tab>
        <v-tab-item>
          <GroupsTable />
        </v-tab-item>
      </v-tabs>
    </Modal>
  </div>
</template>

<script>
import Modal from "../../../../shared/Modal";
import UsersTable from "../../../table/users/UsersTable";
import GroupsTable from "../../../table/users/GroupsTable";

export default {
  components: {
    Modal,
    UsersTable,
    GroupsTable
  },
  data: () => ({
    register: true
  }),
  computed: {
    users() {
      return this.$store.getters.getUsers;
    }
  },
  methods: {
    initTable() {
      this.$root.$emit("initTable");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/settings/modals/userManagement/Users.vue